export default "__VITE_ASSET__COMAFDe$__"